export default function createMarkup(data) {
    return {__html: data};
}